<template>
  <div
    class="lm-dropdown"
    @keydown.esc="closeContent"
    >
    <button @click="toggleContent" type="button" class="btn btn-secondary btn-secondary-custom">
      <font-awesome-icon icon="sliders-h" />
      <span class="filter">{{ toggleContentButtonText }}</span>
      <i class="noti-icon-badge" v-if="selectedAgregates.length"/>
      <span
        class="selected-aggregate d-inline-flex justify-content-center align-items-center ml-1"
        v-if="selectedAgregates.length"
      >
        {{selectedAgregates.length}}
      </span>
    </button>
    <div
      class="content"
      v-if="isContentShow"
      @keydown.esc="closeContent"
      tabindex="-1"
      ref="content"
      >
        <lmLoading v-if="loading" />
        <template v-for="(selectedAgregate) in selectedAgregates">
          <button
            v-for="(value, key) in selectedAgregate"
            :key="`value-${key}`"
            class="btn btn-link remove-aggregate mr-2 mb-2 d-inline-flex align-items-center js-no-hide-click-outside"
            @click="unSelectAggregate(key, value)"
            >
              <span class="js-no-hide-click-outside">{{ value }}</span>
              <font-awesome-icon icon="times" class="js-no-hide-click-outside" />
          </button>
        </template>
        <button
          v-if="selectedAgregates.length"
          id="clean-all-selected-agregates"
          class="btn btn-link pl-0 d-block js-no-hide-click-outside"
          @click="cleanAllSelectedAgregates">{{$t('clean_filters')}}</button>
      <h4>Resultados Obtenidos: {{totalResult}}</h4>
      <h4>Ordenar Resultados</h4>
      <div class="d-flex">
        <div class="wrapper-order">
          <div
            class="option-showed d-flex align-items-center"
            @click="toggleContentOptionShow"
            >
            <span>{{ keyReadableForHuman(optionShowed) }}</span>
            <i class="dripicons" :class="[
                  {'dripicons-chevron-up': isContentOptionShow},{'dripicons-chevron-down': !isContentOptionShow}
                ]" />
          </div>
          <div class="wrapper-asc-desc-div d-inline-block"></div>
          <ul class="options" v-if="isContentOptionShow">
            <li
              v-for="(option, index) in options"
              :key="`option-${index}`"
              @click="dropdownChange(option)"
              :class="{active: option === optionShowed }">
              {{keyReadableForHuman(option)}}
            </li>
          </ul>
        </div>
        <div class="wrapper-asc-desc">
          <font-awesome-icon
            id="wrapper-asc-desc-icon"
            :icon="orderAscDescData === 'asc' ? 'sort-alpha-up' : 'sort-alpha-down'"
            @click="changeorderAscDesc"
            />
        </div>
      </div>
      <template v-for="(aggregate, key, index) in aggregates">
        <div
          :key="`aggregate-${index}`"
          class="aggregates"
          v-if="aggregate.frontEndVisiblity"
          >
            <h4>{{ keyReadableForHuman(key) }}</h4>
            <ul>
              <li
                @click="filterByAggregate({[key]: el.label})"
                v-for="(el, index) in aggregate.content"
                :key="`el-${index}`"
                class="d-none"
                :class="{'d-block': aggregates[key].showAll | showAllAggregates(index)}"
                >
                <span class="aggregates__label">{{ el.label }}</span>
                <span class="aggregates__count">({{el.count}})</span>
              </li>
            </ul>
            <button
              class="btn btn-link p-0 see-more-button"
              v-if="mustShowSeeMoreButton(aggregate.content.length)"
              @click="seeMore(key)">
                {{ aggregates[key].showAll ? 'Ver menos' : 'Ver más' }}
              </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSortAlphaUp, faSortAlphaDown, faTimes, faSlidersH } from '@fortawesome/free-solid-svg-icons'
import lmLoading from '@/components/LmComponentLoading.vue'
import keyReadableForHuman from '@/helpers/key-readable-for-humans.js'
library.add(faSortAlphaUp, faSortAlphaDown, faTimes, faSlidersH)

export default {
  data () {
    return {
      isContentShow: false,
      isContentOptionShow: false,
      optionShowed: this.optionSelected ? this.optionSelected : this.options[0],
      orderAscDescData: this.orderAscDesc,
      widerColumn: false
    }
  },
  components: {
    lmLoading
  },
  computed: {
    toggleContentButtonText () {
      return this.isContentShow ? this.$t('hide_filters') : this.$t('show_filters')
    },
    selectedAgregatesValues: function () {
      return this.selectedAgregates.map((element, index) => {
        let key = Object.keys(element)
        return element[key]
      })
    }
  },
  methods: {
    mustShowSeeMoreButton (aggregateItemLength) {
      return aggregateItemLength > this.showMoreAggregatesItemsAt
    },
    seeMore (key) {
      if (!this.aggregates[key].showAll) {
        this.$set(this.aggregates[key], 'showAll', true)
      } else {
        this.aggregates[key].showAll = false
      }
    },
    keyReadableForHuman (key) {
      return keyReadableForHuman(key)
    },
    showAllAggregates (filterIndex) {
      const result = filterIndex < this.showMoreAggregatesItemsAt
      return result
    },
    unSelectAggregate (key, value) {
      const index = this.selectedAgregates.findIndex(el => el[key] === value)
      this.$refs.content.focus()
      this.$emit('unSelectedAggregate', index)
    },
    cleanAllSelectedAgregates () {
      this.$emit('cleanAllSelectedAgregates')
    },
    filterByAggregate (aggregate) {
      this.$emit('filteredByAggregate', aggregate)
    },
    dropdownChange (option) {
      this.$emit('dropdownChange', option)
      this.optionShowed = option
      this.isContentOptionShow = false
    },
    toggleContent () {
      this.isContentShow = !this.isContentShow
    },
    closeContent () {
      this.isContentShow = false
    },
    toggleContentOptionShow () {
      this.isContentOptionShow = !this.isContentOptionShow
    },
    changeorderAscDesc () {
      this.orderAscDescData = this.orderAscDescData === 'asc' ? 'desc' : 'asc'
      this.$emit('orderAscDescChanged', this.orderAscDescData)
      this.isContentShow = false
    }
  },
  props: {
    selectedAgregates: {
      type: Array
    },
    options: {
      type: Array,
      default: function () {
        return []
      }
    },
    optionSelected: {
      type: String,
      default: ''
    },
    orderAscDesc: {
      type: String,
      default: 'desc'
    },
    loading: {
      type: Boolean,
      default: false
    },
    aggregates: null,
    totalResult: {
      type: Number,
      default: 0
    },
    showMoreAggregatesItemsAt: {
      type: Number,
      default: Number(process.env.VUE_APP_SHOW_MORE_AGGREGATES_ITEMS_AT) || 30
    }
  }
}
</script>

<style lang="sass" scoped>
.lm-dropdown
  position: relative
  .btn-secondary-custom
    color: #6c757d
    background-color: #fff
    border-color: #ced4da
    &:active,
    &:not(:disabled):not(.disabled):active,
    &.btn-secondary:not(:disabled):not(.disabled).active,
    &.show > .btn-secondary.dropdown-toggle
      color: #6c757d
      background-color: #fff
      border-color: #ced4da
      outline: none
    &:focus
      box-shadow: 0 2px 6px 0 rgba(108, 117, 125, 0.5) !important
  .noti-icon-badge
    display: inline-block
    position: absolute
    top: 8px
    left: 10px
    border-radius: 50%
    height: 7px
    width: 7px
    background-color: #fa5c7c
  .wrapper-order
    position: relative
  .filter
    margin-left: 10px
  .option-showed
    cursor: pointer
    [class^="dripicons-"]:before,
    [class*=" dripicons-"]:before
      vertical-align: middle
      margin-left: 5px
  .content
    position: absolute
    right: 0
    left: -25px
    z-index: $zIndexLmDropdownTableCustom
    background: #dee2e6
    border: 1px solid #dee2e6
    padding: 20px
    box-shadow: $box-shadow
    width: 100vw
    @media(min-width: $md)
      width: 320px
      left: auto
      max-height: 1400px
      overflow: auto
    .remove-aggregate
      color: $primaryFontThemeColor
      background: white
      span
        margin-right: 10px
        white-space: nowrap
        max-width: 85px
        overflow: hidden
        text-overflow: ellipsis
        text-align: left
    .aggregates
      cursor: pointer
      .aggregates__count
        color: #999ea2
        margin-left: 5px
      .see-more-button
        margin-top: -28px
    .options
      margin-top: 15px
      li
        cursor: pointer
        padding: 5px
        &:hover
          background: white
  .active
    background: white
  .wrapper-asc-desc
    cursor: pointer
    margin-left: 20px
    position: relative
  .wrapper-asc-desc-div
    padding-left: 10px
    height: 20px
    position: absolute
    border-left: 1px solid #6c757d
    right: -20px
    top: 0
  .selected-aggregate
    border-radius: 50%
    color: white
    background: $dangerThemeColor
    font-weight: 700
    font-size: 12px
    width: 22px
    height: 22px
</style>
